// src/app/common/util/dateUtils.ts
import i18n from '../../../i18n';

const getLocaleFromLanguage = (language: string): string => {
  const localeMap: { [key: string]: string } = {
    'en': 'en-US',
    'zh': 'zh-CN',
    'es': 'es-ES',
    'hi': 'hi-IN',
    'ar': 'ar-SA',
    'pt': 'pt-PT',
    'ru': 'ru-RU',
    'bn': 'bn-BD',
    'fr': 'fr-FR',
    'de': 'de-DE',
    'ja': 'ja-JP',
    'ur': 'ur-PK',
    'ro': 'ro-RO',
    'it': 'it-IT',
    'hu': 'hu-HU',
    'el': 'el-GR',
    'tr': 'tr-TR',
    'sr': 'sr-RS',
    'srLatn': 'sr-Latn-RS'
  };
  return localeMap[language] || language;
};

const formatDateDisplay = (date: Date | string): string => {
  const locale = getLocaleFromLanguage(i18n.language);
  // Ensure we have a Date object
  const dateObj = date instanceof Date ? date : new Date(date);
  
  return dateObj.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

// You might also want to add other date formatting utilities
const formatTimeDisplay = (date: Date | string): string => {
  const locale = getLocaleFromLanguage(i18n.language);
  const dateObj = date instanceof Date ? date : new Date(date);
  
  return dateObj.toLocaleTimeString(locale, {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

const formatDateTimeDisplay = (date: Date | string): string => {
  const locale = getLocaleFromLanguage(i18n.language);
  const dateObj = date instanceof Date ? date : new Date(date);
  
  return dateObj.toLocaleString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

export {
  getLocaleFromLanguage,
  formatDateDisplay,
  formatTimeDisplay,
  formatDateTimeDisplay
};